import { render, staticRenderFns } from "./ProductDashboardReviews.vue?vue&type=template&id=051bf2f3"
import script from "./ProductDashboardReviews.vue?vue&type=script&lang=js"
export * from "./ProductDashboardReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports